<section id="board">
    

      <!-- Wallet Actions -->
      <h2 class="h5 pl-3 text-uppercase">Settings</h2>
      <section class="no-padding-top no-padding-bottom">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> </div><strong>update profile info</strong>
                  </div>
                  <div class="number dashtext-1"> <i class="fa fa-user"></i> </div>
                </div>
               
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> </div><strong>password manager</strong>
                  </div>
                  <div class="number dashtext-1"> <a routerLink="" style="cursor: pointer; color: inherit;" > <i class="fa fa-key"></i> </a></div>
                </div>
               
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> </div><strong>Intra Banking</strong>
                  </div>
                  <div class="number dashtext-1"><a routerLink=""  type="button" data-toggle="modal" data-target="#joinThrift" style="cursor: pointer; color: inherit;"><i class="fa fa-handshake"></i></a> </div>
                </div>
               
              </div>
            </div>
            <div class="col-md-3 col-sm-6">
              <div class="statistic-block block">
                <div class="progress-details d-flex align-items-end justify-content-between">
                  <div class="title">
                    <div class="icon"> </div><strong>chat service</strong>
                  </div>
                  <div class="number dashtext-1"> <a href="https://chatting.page/co0jjuu58obrlhqogcqzsre8ocltfxpa" style="cursor: pointer; color: inherit;"><i class="fa fa-keyboard"></i></a> </div>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section>

   
    

</section>



